var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-icon"},[(_vm.iconType === 'md_icon')?_c('v-icon',{staticClass:"material-icons",attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.iconName))]):(_vm.iconType === 'md_symbol')?_c('span',{staticClass:"material-symbols-outlined v-icon",class:_vm.colorizeSymbol(_vm.iconColor)},[_vm._v(_vm._s(_vm.iconName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }